<section class="content overtime-page">
  <div class="content-block overtime-page__content">
    <div class="block-header overtime-page__header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('overtimesCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="overtime-list-workspace">
      <app-master-table [title]="'overtimesCatalog.title' | translate"
                        [columnDefinitions]="columnDefinitions"
                        [dataSource]="dataSource"
                        [isLoading]="isLoading"
                        [actions]="actions"
                        [filters]="tableFilters"
                        [showSearch]="false"
                        [showCheckbox]="true"
                        [enableRowClick]="true"
                        [disableRowClickToEdit]="true"
                        [rowClickSelection]="false"
                        [useServerData]="true"
                        [totalItems]="totalItems"
                        [currentPage]="currentPage"
                        [pageSize]="pageSize"
                        [pageSizeOptions]="[15, 25, 50, 100, 200]"
                        [tableMaxHeight]="'100%'"
                        exportFileName="overtimes"
                        (rowClick)="handleView($event)"
                        (details)="handleView($event)"
                        (refresh)="loadData()"
                        (filtersChange)="onFiltersChange($event)"
                        (filterSearchChange)="onFilterSearchChange($event)"
                        (pageChange)="onPageChange($event)"
                        (actionTriggered)="handleActionTriggered($event)">
      </app-master-table>
    </div>
  </div>
</section>
